





































































































































import { defineComponent, toRefs, watch } from "@vue/composition-api";

import store from "@/store/root";
import ProcessStep from "@/components/steps/ProcessStep.vue";

export default defineComponent({
  name: "PdfForm",
  components: { ProcessStep },
  props: {
    machine: { type: Object }
  },
  setup(props) {
    watch(
      () => props.machine.state.value.context.document,
      value => {
        store.dispatch("updateRaw", value[0].text);
      }
    );

    return props.machine;
  }
});
